import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * C2PFステータス更新
 */
@Injectable()
export class UpdateC2pfStatusService extends PlessJsonResponderSub<any> {
  private successFunc: Function;
  private remandReason: string;
  private imageFileNameList: string[];
  private updateStatus: string;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof UpdateC2pfStatusService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      update: {
        updateC2pfStatus: {
          condition: {
            UpdateStatus: this.updateStatus,
            RemandReason: this.remandReason
          }
        },
        ImageFileNameList: {
          combination: this.imageFileNameList.map(_ => {
            return {
              condition: {
                ImageFileName: _
              }
            }
          })
        }
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param {Function} [successFunc=null]
   * @memberof UpdateC2pfStatusService
   */
  execute(imageFileNameList: string[], remandReason: string, status: string, successFunc: Function = null): void {
    this.imageFileNameList = imageFileNameList;
    this.remandReason = remandReason;
    this.successFunc = successFunc;
    this.updateStatus = status;
    this.send('KYMW17UpdateC2pfStatus', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof UpdateC2pfStatusService
   */
  success(data: any): void {
    if (this.successFunc !== null) {
      this.successFunc();
    }
  }
}
